<template>
  <v-toolbar class="colorn">
    <v-container fluid mx-4 pa-0 fill-height>
      <v-row class="flex-nowrap">
        <div class="mr-2">
          <v-chip
            v-for="filter in Object.keys(flagFilters)"
            :key="'profile-' + filter"
            :style="{display: flagFilters[filter] ? 'inline-flex' : 'none'}"
            class="ma-1 font-weight-medium white--text"
            color="colorPrimary2"
          >
            {{flagFilters[filter] === 'Yes' ? filter : `not ${filter}`}}
            <v-icon class="ml-1" size="18" @click="() => removeFlagFilter(filter)">mdi-close</v-icon>
          </v-chip>
        </div>

        <v-spacer/>
        <cvc-multi-drop-down
          title="Filters"
          :title-color="$vuetify.theme.currentTheme.colorPrimary1"
          :initial="$store.state.profileReview.flagFilters"
          :groups="flagGroups"
          :on-change="setFlagFilters"
        />
      </v-row>
    </v-container>
  </v-toolbar>
</template>

<script>
import CvcMultiDropDown from "@/components/CvcFields/CvcMultiDropdown";
export default {
  name: "ProfileFilters",
  components: {CvcMultiDropDown},
  computed: {
    flagFilters() {
      return this.$store.state.profileReview.flagFilters;
    },
  },
  data() {
    return {
      tagGroups: [
        {
          title: 'Tags',
          items: [],
          key: 'tags'
        },
      ],
      flagGroups: [
        {
          title: 'Released',
          items: ['Yes', 'No'],
          key: 'released'
        },
        {
          title: 'Deleted',
          items: ['Yes'],
          key: 'deleted'
        },
        {
          title: 'Expired',
          items: ['Yes'],
          key: 'expired'
        },
      ]
    }
  },
  methods: {
    removeFlagFilter(filter) {
      const filters = Object.assign(this.$store.state.profileReview.flagFilters, {});
      filters[filter] = null;
      this.$store.dispatch('setFlagFilters', {filters});
    },
    setFlagFilters(filters) {
      this.$store.dispatch('setFlagFilters', {filters});
    }
  }
}
</script>

<style scoped>

</style>